import React, { useEffect, useState } from "react";
import "./SupportSidebar.css";

import {
    FaSearch,
    FaHeadset
} from "react-icons/fa";
import API from "../../../../../utils/apiCalling";
import { config } from "../../../../../utils/apiUrl";
import socket from "../../../../../socket/socket";

const SupportSidebar = ({
    tickets,
    setTickets,
    selectedTicket,
    setSelectedTicket
}) => {

    const api = new API()
    const [search, setSearch] = useState("");

    const filteredTickets = tickets.filter((ticket) => {

        const keyword = search.toLowerCase();

        return (
            ticket.userId?.mobile?.toLowerCase().includes(keyword)
        );

    });

    useEffect(() => {
        socket.on("ticketRead", ({ ticketId }) => {
            setTickets(prev =>
                prev.map(ticket =>
                    ticket._id === ticketId
                        ? {
                            ...ticket,
                            unreadCount: 0
                        }
                        : ticket
                )
            );

        });
        return () => socket.off("ticketRead");
    }, [setTickets]);

    const onSelectTicketHandler = async (ticket) => {
        setSelectedTicket(ticket);
        await api.put(`${config.markRead}/${ticket._id}`);
        setTickets(prev =>
            prev.map(item =>
                item._id === ticket._id
                    ? {
                        ...item,
                        unreadCount: 0
                    }
                    : item
            )
        );
    };

    return (

        <div className="support-sidebar">

            {/* Header */}

            <div className="sidebar-header">

                <h2>

                    <FaHeadset />

                    Support

                </h2>

            </div>

            {/* Search */}

            <div className="sidebar-search">

                <FaSearch className="search-icon" />

                <input
                    type="text"
                    placeholder="Search ticket..."
                    value={search}
                    onChange={(e) =>
                        setSearch(e.target.value)
                    }
                />

            </div>

            {/* Ticket List */}

            <div className="ticket-list">

                {
                    filteredTickets.length === 0 ?

                        <div className="no-ticket">

                            No Support Tickets

                        </div>

                        :

                        filteredTickets.map(ticket => (

                            <div
                                key={ticket._id}
                                className={`ticket-item ${selectedTicket?._id === ticket._id
                                    ? "active"
                                    : ""
                                    }`}
                                onClick={() =>
                                    onSelectTicketHandler(ticket)
                                }
                            >

                                <div className="ticket-avatar">

                                    {ticket.user?.fullName?.charAt(0) || "U"}

                                </div>

                                <div className="ticket-content">

                                    <div className="ticket-top">

                                        <h4>

                                            {
                                                ticket.userId?.mobile ||
                                                "Unknown User"
                                            }

                                        </h4>

                                        <span>

                                            {
                                                new Date(
                                                    ticket.updatedAt
                                                ).toLocaleDateString()
                                            }

                                        </span>

                                    </div>

                                    <div className="ticket-bottom">

                                        <p>

                                            {
                                                ticket.lastMessage ||
                                                "No messages yet"
                                            }

                                        </p>

                                        <div className="ticket-right">

                                            <span>

                                                {(ticket.updatedAt)}

                                            </span>

                                            {

                                                ticket.unreadCount > 0 && (

                                                    <div className="unread-badge">

                                                        {ticket.unreadCount}

                                                    </div>

                                                )

                                            }

                                        </div>

                                    </div>

                                </div>

                            </div>

                        ))

                }

            </div>

        </div>

    );

};

export default SupportSidebar;